import { DELIVERY_CHARGES_FIELDS, CHARGE_TYPE, getItemKey } from "./constants";

export const validateDeliveryDistances = (value, index, deliveryCharges, errors, maxRange) => {
    const errorKey = getItemKey(index, DELIVERY_CHARGES_FIELDS.MAX, CHARGE_TYPE.DELIVERY);
    if (!value) {
        errors.set(errorKey, "Max distance is required");
        return;
    }
    value = Number(value);
    const prevCharge = index > 0 ? deliveryCharges[index - 1] : null;
    if (value > maxRange) {
        errors.set(errorKey, "Max distance must be less than " + maxRange + " miles");
        return;
    }
    if (prevCharge && (value <= Number(deliveryCharges[index].minDistance))) {
        errors.set(errorKey, "Distance must be greater min distance");
        return;
    }

    // Remove error if value is valid
    errors.delete(errorKey);
}
export const validateAmount = (value, field, index, chargeType, errors) => {
    const errorKey = getItemKey(index, field, chargeType);
    if (value === "" || value === null || value === undefined) {
        errors.set(errorKey, "Amount is required");
        return;
    }
    const chargeAmount = Number(value);
    if (chargeType === CHARGE_TYPE.DELIVERY && index > 0 && chargeAmount === 0) {
        errors.set(errorKey, "Amount must be greater than 0");
        return;
    }

    if (chargeType === CHARGE_TYPE.OTHER && chargeAmount === 0) {
        errors.set(errorKey, "Amount must be greater than 0");
        return;
    }

    if (chargeAmount < 0) {
        errors.set(errorKey, "Amount must be greater than 0");
        return;
    }

    // Remove error if value is valid
    errors.delete(errorKey);
}